<template>
  <div
    v-if="shouldRenderConfig"
    v-show="alwaysShow || getShowUpload"
    :class="[
      getClassName,
      getAttribute('statusUploaded') ? getClassName + 'Uploaded' : '',
      getAttribute('isLoading') ? getClassName + 'IsLoading' : ''
    ]"
  >
    <appUploadDropzone
      :propsData="propsData"
      :excel="excel"
    ></appUploadDropzone>
    <div
      v-show="getAttribute('isLoading')"
      :class="getClassName + 'LoadingContainer'"
    >
      <LvProgressBar
        :value="getAttribute('loadingProgress')"
        style="width: 100%"
      ></LvProgressBar>
      <div :class="getClassName + 'LoadingValue'">
        {{ parseInt(getAttribute("loadingProgress")) + " %" }}
      </div>
    </div>
    <div
      v-if="getAttribute('statusUploaded')"
      :class="getClassName + 'Preview'"
    >
      <appUploadName
        v-if="getBundleIsActive"
        :ppName="propsData.label"
      ></appUploadName>
      <appUploadPreview
        v-if="getShowPreviewInUpload && getAttribute('previewFile')"
        :propsData="propsData"
        :useClassName="getClassName + 'PreviewContainer'"
      >
      </appUploadPreview>
      <div
        v-if="!(getShowPreviewInUpload && getAttribute('previewFile'))"
        class="filename"
      >
        {{ getAttribute("uploadedFile") }}
      </div>
      <div :class="getClassName + 'StatusContainer'">
        <appUploadPreflight
          :propsData="propsData"
          :useClassName="getClassName + 'PreflightContainer'"
        ></appUploadPreflight>
        <appUploadActions
          :propsData="propsData"
          :useClassName="getClassName + 'ActionsContainer'"
        ></appUploadActions>
      </div>
    </div>
  </div>
</template>
<script>
import { useConfigStore } from "@/stores/modules/config";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { usePreflightPitstopStore } from "@/stores/modules/preflightPitstop";
import { useUrlsStore } from "@/stores/modules/urls";
import { useUploadsStore } from "@/stores/modules/uploads";
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { useBundleStore } from "@/stores/modules/bundle";

import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useConfigStore, ["getShowUpload"]),
    ...mapState(useWebproductStore, [
      "getSelectionId",
      "getShowPreviewInUpload",
      "getIsPackingEnabled",
      "getIsPreflighPitstop"
    ]),
    ...mapState(usePreflightPitstopStore, [
      "getPitstopFileIsLoading",
      "getPitstopFileStatusResponse",
      "getTimer"
    ]),
    ...mapState(useUrlsStore, ["getUrl"]),
    ...mapState(useChangeOptionsStore, ["getSelectedOption"]),
    ...mapState(useUploadsStore, [
      "getUploadForProductPart",
      "getFileParameters"
    ]),
    ...mapState(useBundleStore, ["getBundleIsActive"])
  },
  methods: {
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "alwaysShow", "excel"]
};
</script>
